import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["match", "whereabouts", "matchedRoutes", "index", "Child"];

var _dec, _class, _class2, _temp;

import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/jsx-no-bind */
import React, { Component, Suspense as _Suspense } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import invariant from 'invariant';
import warning from 'warning';
import { match, matchMany, replace, push, pop } from '@rexlabs/whereabouts';
import { withWhereabouts } from './connectors';
import { __DEV__ } from './utils/env';
var RenderMatchedRoutes = (_dec = withWhereabouts(), _dec(_class = autobind(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(RenderMatchedRoutes, _Component);

  var _super = _createSuper(RenderMatchedRoutes);

  function RenderMatchedRoutes() {
    _classCallCheck(this, RenderMatchedRoutes);

    return _super.apply(this, arguments);
  }

  _createClass(RenderMatchedRoutes, [{
    key: "Suspense",
    value: function Suspense(_ref) {
      var _this = this;

      var match = _ref.match,
          whereabouts = _ref.whereabouts,
          matchedRoutes = _ref.matchedRoutes,
          index = _ref.index,
          Child = _ref.Child,
          props = _objectWithoutProperties(_ref, _excluded);

      var params = (match === null || match === void 0 ? void 0 : match.params) || {};
      return /*#__PURE__*/React.createElement(_Suspense, props, /*#__PURE__*/React.createElement(Child, _extends({}, props, params, {
        key: match.key,
        match: match,
        whereabouts: whereabouts // NOTE: we leave this in for backwards compatibility for now, but ideally
        // we want to move to `onClose`, since it's less opinionated about naming when
        // it comes to `Dialog` / `Modal` :D
        ,
        closeModal: function closeModal() {
          if (__DEV__) {
            console.warn("'closeModal' is deprecated and will eventually be removed. " + "Use 'onClose' instead.");
          }

          _this.closeModal(matchedRoutes[index - 1]);
        },
        onClose: function onClose() {
          return _this.closeModal(matchedRoutes[index - 1]);
        } // For unit tests we want to be able to access the
        // key prop value!

      }, __DEV__ ? {
        devKey: match.key
      } : {})));
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Only rerender if any of the relevant props changed!
      if (this.props.routes === nextProps.routes && this.props.whereabouts === nextProps.whereabouts && this.props.location === nextProps.location) {
        return false;
      }

      return true;
    } // Simply runs `matchMany` on the given routes object, which will (hopefully)
    // return an array we can use for rendering the routes!

  }, {
    key: "getMatchedRoutes",
    value: function getMatchedRoutes() {
      var _this$props = this.props,
          routes = _this$props.routes,
          location = _this$props.location,
          whereabouts = _this$props.whereabouts;
      return matchMany(location || whereabouts, routes);
    } // Close the modal by either pushing a new location to the parent match route
    // or simply poping the history if the last location was the parent match
    // NOTE: this is very opinionated and needs to be discussed to make sure we
    // implement the most intuitive behaviour!

  }, {
    key: "closeModal",
    value: function closeModal(parentMatch) {
      var _context;

      var whereabouts = this.props.whereabouts;

      if (!parentMatch) {
        return;
      }

      var currIndex = _findIndexInstanceProperty(_context = whereabouts.history).call(_context, function (entry) {
        return entry.id === whereabouts.id;
      });

      var prevLocation = whereabouts.history[currIndex - 1];

      try {
        if (prevLocation && match(prevLocation, parentMatch.route)) {
          pop();
        } else {
          push({
            config: parentMatch.route
          }, {
            params: parentMatch.params
          });
        }
      } catch (e) {
        warning(!e, 'Something went wrong during pop attempt! Pushing new route instead!');
        push({
          config: parentMatch.route
        }, {
          params: parentMatch.params
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          whereabouts = _this$props2.whereabouts,
          routes = _this$props2.routes,
          location = _this$props2.location,
          NotFound = _this$props2.NotFound,
          fallback = _this$props2.fallback,
          children = _this$props2.children;
      var matches = null; // Find matches and render them looping through the match array

      var matchedRoutes = this.getMatchedRoutes();

      if (matchedRoutes && matchedRoutes.length) {
        matches = _mapInstanceProperty(matchedRoutes).call(matchedRoutes, function (match, i) {
          var Component = match.route.Component;

          if (match.route.redirect) {
            // Redirect can be defined as function that returns an object
            // or as an object directly. If the function return falsy,
            // there will be no redirect (to allow e.g. conditional redirects)
            var target = null;

            if (typeof match.route.redirect === 'function') {
              target = match.route.redirect(whereabouts);
            } else {
              target = match.route.redirect;
            }

            if (target) {
              replace({
                config: target
              });
              return null;
            }
          }

          invariant(Component, "No component found to be rendered for route '".concat(match.key, "'!"));
          var component = /*#__PURE__*/React.createElement(Component, _extends({
            key: match.key,
            match: match,
            whereabouts: whereabouts // NOTE: we leave this in for backwards compatibility for now, but ideally
            // we want to move to `onClose`, since it's less opinionated about naming when
            // it comes to `Dialog` / `Modal` :D
            ,
            closeModal: function closeModal() {
              if (__DEV__) {
                console.warn("'closeModal' is deprecated and will eventually be removed. " + "Use 'onClose' instead.");
              }

              _this2.closeModal(matchedRoutes[i - 1]);
            },
            onClose: function onClose() {
              return _this2.closeModal(matchedRoutes[i - 1]);
            } // For unit tests we want to be able to access the
            // key prop value!

          }, __DEV__ ? {
            devKey: match.key
          } : {}));

          if (!_Suspense) {
            return component;
          }

          var WrappedSuspense = _this2.Suspense;
          return /*#__PURE__*/React.createElement(WrappedSuspense, _extends({
            key: match.key
          }, __DEV__ ? {
            devKey: match.key
          } : {}, {
            fallback: fallback,
            match: match,
            whereabouts: whereabouts,
            matchedRoutes: matchedRoutes,
            index: i,
            Child: Component
          }));
        });

        if (typeof children === 'function') {
          return children(matches);
        }

        return matches;
      }

      matches = NotFound ? /*#__PURE__*/React.createElement(NotFound, {
        routes: routes,
        location: location || whereabouts
      }) : null;

      if (typeof children === 'function') {
        return children(matches);
      }

      return matches;
    }
  }]);

  return RenderMatchedRoutes;
}(Component), _defineProperty(_class2, "propTypes", {
  routes: PropTypes.object.isRequired,
  location: PropTypes.object,
  NotFound: PropTypes.oneOfType([PropTypes.func]),
  Fallback: PropTypes.element,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.func])
}), _defineProperty(_class2, "defaultProps", {
  fallback: null
}), _temp)) || _class) || _class);
export default RenderMatchedRoutes;